import { Cell, InfoLabel } from 'bold-ui'
import React, { Fragment } from 'react'

import { AntropometriaAccordionModel } from './AntropometriaAccordion'

interface PacMembroInferiorReadOnlyProps {
  values: Pick<AntropometriaAccordionModel, 'membroInferiorDireito' | 'membroInferiorEsquerdo'>
}

export function PacMembroInferiorReadOnly(props: Readonly<PacMembroInferiorReadOnlyProps>) {
  const { values } = props

  return (
    <Fragment>
      <Cell size={6}>
        <InfoLabel title='Membro inferior direito'>{values?.membroInferiorDireito}</InfoLabel>
      </Cell>
      <Cell size={6}>
        <InfoLabel title='Membro inferior esquerdo'>{values?.membroInferiorEsquerdo}</InfoLabel>
      </Cell>
    </Fragment>
  )
}
